import { postData } from '@datavant/idsb-shared/utils';

export enum SlackChannelEnum {
    // Instructions found here: https://slack.dev/node-slack-sdk/web-api
    // Conversation ID - find in URL using web Slack client
    IDSB_PORTAL_ONCALL = 'C0571BKE604',
    REQUEST_MANAGER_ONBOARDING_CUSTOMER_EXPERIENCE = 'C060N9N5Y8P',
    PROVIDER_XP_HEALTH_SYSTEMS_POCS = 'C05MXQ72M8X',
    STAGING_REQUEST_MANAGER_SLACK_ALERTS = 'C069MU38E07',
    IDSB_PROVIDER_PRODUCT_ALERTS = 'C066J8T7X45',
    BURNER = 'C063ST4NZGX',
    NONEMBEDDED_DIGITAL_IMPLEMENTATIONS = 'C084NH3A6SJ',
    NONEMBEDDED_DIGITAL_LEADS = 'C08E5T1SE84',
    RRA_SIGNED_AGREEMENTS = 'C08PTCWULGP',
    PROVIDER_EXCHANGE_LEADS = 'C0BHED3A9D5',
}

// General-inquiry alerts share the same Slack channel as onboarding/customer-experience.
export const RM_GENERAL_INQUIRY_CHANNEL = SlackChannelEnum.REQUEST_MANAGER_ONBOARDING_CUSTOMER_EXPERIENCE;

export const sendSlackAlert = async (channel: string, contents: string): Promise<void> => {
    return await postData('/api/slack', { channel, contents });
};
